/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/*eslint no-console: 0, dot-notation: 0 */

(function() {
    "use strict";
    // temporarily force localStorage locale to US English
    // this will prevent dc-core from  trying to load strings from other locales
    // by checking  window.navigator.language
    window.localStorage.setItem('locale', 'en-US');

    var sdk = window.adobe_dc_sdk, options = sdk.launchOptions,
        logToConsole = /[?&]app!logging=console/.test(window.location.search),
        loggerDefer = new sdk.util.Deferred(),
        oneTrustWebPrivacyPath = 'https://www.adobe.com/etc/beagle/public/globalnav/adobe-privacy/latest/privacy.min.js',
        webAnalyticsPath = 'https://www.adobe.com/marketingtech/main.min.js',
        launcher = sdk.appLauncher,
        availableCookies = ['C0001', 'C0002', 'C0003', 'C0004'], envScript,
        domLoaded = new sdk.util.Deferred();
    document.addEventListener("DOMContentLoaded", function() {
        domLoaded.resolve();
    });

    sdk.loaded.webAppDropinDefer = new sdk.util.Deferred();
    window.addEventListener('load', function() {
        sdk.loaded.webAppDropinDefer.resolve();
    });

    sdk.gdpr_consent = false;
    window.addEventListener("adobePrivacy:PrivacyConsent", function() {
        sdk.gdpr_consent = true;
    });

    // Defined a semi-private, non-enumerable property to reference for unit testing.
    Object.defineProperty(sdk, "_appLauncher", {value: {}});

    function execRules() {
        var core = launcher.coreFunction();

        // Load privacy after webAppDropinDefer.
        sdk.loaded.webAppDropinDefer.promise.then(function () {
            window.addEventListener("adobePrivacy:PrivacyCustom", function () {
                // returns array with cookie category/host strings
                var allowedCookieGroups = window.adobePrivacy.activeCookieGroups(),
                    allCookiesAccepted = true;
                // eslint-disable-next-line one-var
                for (var i = 0; i < availableCookies.length; i++) {
                    if (allowedCookieGroups.indexOf(availableCookies[i]) === -1) {
                        allCookiesAccepted = false;
                        break;
                    }
                }
                if (allCookiesAccepted) {
                    sdk.gdpr_consent = true;
                } else {
                    // set the gdpr_consent to false in case user changes the settings from personalize option
                    sdk.gdpr_consent = false;
                }
            });
            window.addEventListener("adobePrivacy:PrivacyReject", function () {
                sdk.gdpr_consent = false;
            });
            // Variables that needs to be set for OneTrust Banner
            window.fedsConfig = window.fedsConfig || {};
            window.fedsConfig.privacy = window.fedsConfig.privacy || {};
            if (options.env === "prod"){
                window.fedsConfig.privacy.otDomainId = "7a5eb705-95ed-4cc4-a11d-0cc5760e93db";
            } else {
                window.fedsConfig.privacy.otDomainId = "7a5eb705-95ed-4cc4-a11d-0cc5760e93db-test";
            }
            // footerLinkSelector is required for the banner to show up
            window.fedsConfig.privacy.footerLinkSelector = ".one-trust-notice";
            sdk.dom.loadScript(oneTrustWebPrivacyPath).then(function () {
                // Create an empty object here since we want to replace "window.evidon.notice.showConsentTool"
                // with "window.adobePrivacy.showConsentPopup" as it will help us to avoid making this change
                // in multiple repo later.
                window.evidon={notice: {}};
                window.evidon.notice.showConsentTool = window.adobePrivacy.showConsentPopup;
            });
        });
        loggerDefer.resolve(core.logging.getLogger("DCAppLauncher"));
    }

    function loadAnalytics() {
        var marketingEnv = {
            "dev": "dev",
            "stage": "stage",
            "prod": "production"
        }[options.env] || "dev";

        window.marketingtech = {
            adobe: {
                launch: {
                    property: "global",
                    environment: marketingEnv
                },
                analytics: {
                    additionalAccounts: ""
                },
                target: true
            }
        };
        if(options.env === 'prod') {
            window.marketingtech.adobe.analytics.additionalAccounts = "adbdcwebprod,adbadobenonacdcprod,adbadobeprototype";
        } else {
            window.marketingtech.adobe.analytics.additionalAccounts = "adbadobenonacdcqa,adbdcwebqa";
        }
        sdk.dom.loadScript(webAnalyticsPath);
    }

    envScript = sdk.launchOptions.host +
        "/dc-visualizer-app/__VERSION__/private/dc-sdk-" +
        sdk.launchOptions.env +
        "-manifest.js";
    if (options.env === "localdev") {
        envScript = envScript.replace("/dc-visualizer-app", "").replace("localdev", "dev");
    }

    // we must add ims_scope and ims_client_id
    options.ims_scope = 'AdobeID,openid,DCAPI,read_organizations,PDFServicesAPI_UA';

    function handleIMSReady() {
        var event = document.createEvent("Event");
        event.initEvent("dc.imslib.ready", true, true);
        document.dispatchEvent(event);
        window.adobe_dc_sdk.imsReady = true;
    }

    function handleIMSError() {
        var event = document.createEvent("Event");
        event.initEvent("dc.imslib.error", true, true);
        document.dispatchEvent(event);
    }

    options.ims_client_id = {
        prod: 'dc-prod-visualizer',
        stage: 'dc-stage-visualizer',
        dev: 'dc-stage-visualizer',
        localdev: 'dc-stage-visualizer'
    }[options.env];

    window.adobeid = {
        uses_redirect_mode: true,
        client_id: options.ims_client_id,
        scope: options.ims_scope,
        locale: sdk.dom.getLocale(),
        environment: options.env === "prod" ? "prod" : "stg1",

        onReady: function () {
            if (window.adobeIMS.isSignedInUser()) {
                // isSignedInUser would return true if user logged out from another tab
                // and so we always validateToken so that isSignedInUser can return correct value
                window.adobeIMS.validateToken(window.adobeIMS.getAccessToken().token).then(function() {
                    window.adobeIMS.getProfile().then(function(p) {
                        window.adobe_dc_sdk.ims_profile = p;
                        handleIMSReady();
                    }).catch(function() {
                        handleIMSError();
                    });
                }).catch(function() {
                    handleIMSReady();
                });
            } else {
                handleIMSReady();
            }
        },

        onError: function () {
            handleIMSError();
        }
    };

    // When dc-core and imslib are loaded, configure and call DCAPI /discovery.
    sdk.loaded.ims.then(function(ims) {
        if (window.adobeIMS && !window.adobeIMS.isReady) {
            window.adobeIMS.isReady = function () {
                return !!window.adobe_dc_sdk.imsReady;
            };
            window.adobeIMS.getClientID = function () {
                return window.adobeid.client_id;
            };
            window.adobeIMS.getUserProfile = function() {
                return window.adobe_dc_sdk.ims_profile;
            };
            window.adobeIMS.getLocale = function () {
                return window.adobeid.locale;
            };
        }

        sdk.dom.setEnvironment(options.env, envScript).then(function () {
            // The two update_profile scopes are not added to dc-dev-virgoweb,
            // and they need to be removed from all environments later.

            sdk.appLauncher.corePromise.then(function(core) {
                sdk.appLauncher.initLogging("DCVisualizer",
                    sdk.loaded.webAppDropinDefer);
                core.envUtil.setEnvVars({
                    server_env: sdk.launchOptions.env,
                    app_identifier: "dc_visualizer_app"
                });
                return core.providers.discovery(
                    null, window.adobe_dc_sdk.cache.VERSIONS
                ).then(function() {
                    domLoaded.promise.then(function() {
                        sdk.launchApp();
                        execRules();
                        sdk.appLauncher.loadDcCore(logToConsole);

                        window.__targetLoadedPromise = new sdk.util.Deferred();
                        window.adobe_dc_sdk.loaded.webAppDropinDefer.promise.then(
                            function() {
                                // If we are delaying analytics scripts, we need to disable
                                // pre-hiding snippet otherwise we would see a flicker.
                                // Pre-hiding snippet is only needed if we are using global-mbox,
                                // and so far we are not
                                window.targetGlobalSettings = {
                                    bodyHidingEnabled: false
                                };
                                loadAnalytics();
                            });
                    });
                });
            });
        });
    });
}());
